var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolsToManageWealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 8.5C3.5 5.87665 5.62665 3.75 8.25 3.75H24.25C26.8734 3.75 29 5.87665 29 8.5V24.5C29 27.1234 26.8734 29.25 24.25 29.25H8.25C5.62665 29.25 3.5 27.1234 3.5 24.5V8.5ZM8.25 5.25C6.45507 5.25 5 6.70508 5 8.5V24.5C5 26.2949 6.45508 27.75 8.25 27.75H24.25C26.0449 27.75 27.5 26.2949 27.5 24.5V8.5C27.5 6.70507 26.0449 5.25 24.25 5.25H8.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 15.625C11.2332 15.625 11.625 16.0168 11.625 16.5L11.625 21.5C11.625 21.9832 11.2332 22.375 10.75 22.375C10.2668 22.375 9.875 21.9832 9.875 21.5L9.875 16.5C9.875 16.0168 10.2668 15.625 10.75 15.625Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 10.625C16.7332 10.625 17.125 11.0168 17.125 11.5V21.5C17.125 21.9832 16.7332 22.375 16.25 22.375C15.7668 22.375 15.375 21.9832 15.375 21.5V11.5C15.375 11.0168 15.7668 10.625 16.25 10.625Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 12.625C22.2332 12.625 22.625 13.0168 22.625 13.5L22.625 21.5C22.625 21.9832 22.2332 22.375 21.75 22.375C21.2668 22.375 20.875 21.9832 20.875 21.5L20.875 13.5C20.875 13.0168 21.2668 12.625 21.75 12.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsToManageWealth);
export default __webpack_public_path__ + "static/media/tools-to-manage-wealth.cb24306810d3784e87ee060c0f9645e2.svg";
export { ForwardRef as ReactComponent };